import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore constants is in the parent dir
import SKIP_INGEST_EMAIL from '@constants/SkipIngestEmail';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore axios is in the parent dir
import axios from '@utils/axios';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import isProd from '@utils/isProd';

import { Email } from 'types/Email';
import { IngestionMessage } from 'types/IngestionMessage';
import { Maybe } from 'types/UtilityTypes';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

async function triggerIngestEmail(
  threadId?: string,
  ingestionMessage?: IngestionMessage
) {
  // Make an API call to another endpoint to call inboxWebhook
  await axios.post(`email/ingest`, {
    ingestionMessage: ingestionMessage,
    threadId: threadId,
  });
}

export default async function getEmail(
  threadId: string,
  ingestionMessage?: IngestionMessage
): Promise<Result<Maybe<Email>, ApiError>> {
  try {
    const response = await axios.get(
      `email/thread/${encodeURIComponent(threadId!)}`
    );

    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getEmail' });

    const is404Error = isAxiosError(error) && error.response?.status === 404;
    // To make end-to-end testing easier, ingest new emails synchronously.
    if (!isProd() && is404Error && !SKIP_INGEST_EMAIL) {
      triggerIngestEmail(threadId, ingestionMessage);
    }

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get email' });
    }

    return err({
      message: error.response?.data.message || 'Failed to get email',
    });
  }
}
